import { __assign } from "tslib";
// DS: i7.4
import React from 'react';
import IconWrap from '../../IconWrap';
var FullWidthImage = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18 19a1 1 0 010 2H6a1 1 0 010-2zm2-16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z" }))));
};
FullWidthImage.displayName = 'FullWidthImage';
export default FullWidthImage;
//# sourceMappingURL=FullWidthImage.js.map